import React from 'react';
import { motion } from 'framer-motion';
import { painQuestions } from '../data/content';
import { Heading } from './Primitives';
export function PainPoints() {
  return <section aria-label="The everyday questions" className="bg-white px-5 py-10 sm:px-8 sm:py-12" data-id="element-146" data-mp="2lp58p18utkyf">
      <div className="mx-auto w-full max-w-4xl" data-id="element-147" data-mp="2bxixv60fhnw7">
        <div className="mx-auto max-w-2xl text-center" data-id="element-148" data-mp="2bw7uv8et4k65">
          <Heading data-id="element-149" data-mp="1xxrfyu6sjncx">Are you sure you're doing it right?</Heading>
          <p className="mt-3 text-lg leading-relaxed text-ink-500" data-id="element-150" data-mp="1xwgampxp67jp">
            Dog care is full of little decisions. And it's surprisingly easy to guess your way through them.
          </p>
        </div>

        <ul className="mt-7 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-151" data-mp="1o1obvisdpenc">
          {painQuestions.map((question, index) => <motion.li key={question} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          delay: Math.min(index, 4) * 0.04,
          ease: 'easeOut'
        }} className="rounded-xl border border-orangey-100 bg-cream px-4 py-3 font-display text-base font-bold leading-snug text-ink-700" data-id="element-152" data-mp="3idl59hadsul1" data-mpi={index}>
              “{question}”
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-2xl text-center text-lg font-semibold leading-relaxed text-ink-900" data-id="element-153" data-mp="23r55oaa07d24">
          Instead of searching and second-guessing yourself, Pawsy gives you one clear place to start.
        </p>
      </div>
    </section>;
}